import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { CreateFormData, capitalizeEachWord } from '../../config/apiUrl';
import { languagesOptions, roomsOptions } from '../../constant/commonData';
import ModalSkeleton from '../../modals/ModalSkeleton';
import { useDeletePropertyMediaMutation } from '../../store/apiSlice/apiSlice';
import { uploadImagesHelper } from '../../utils/helpers';
import Button from '../Button/Button';
import DropDown from '../DropDown/DropDown';
import FileUpload from '../FileUpload';
import FormLanguages from '../FormLanguages';
import Input from '../Input/Input';
import LottieLoader from '../LottieLoader/LottieLoader';
import UploadImageBox from '../UploadImageBox';
import classes from './UnitAddModal.module.css';
const UnitAddModal = ({ show, setShow, onClick, isApiCall, data }) => {
  const { exteriorAmenities, interiorAmenities, unitTypes } = useSelector(
    (state) => state?.commonReducer
  );
  const [language, setLanguage] = useState(languagesOptions[0]);
  const { accessToken } = useSelector((state) => state.authReducer);

  const [deletePropertyMedia, { isLoading: isDeletingMedia }] = useDeletePropertyMediaMutation();

  const [unitsPrice, setUnitsPrice] = useState(data?.price || '');
  const [unitsType, setUnitsType] = useState(data?.unitType || '');
  const [unitsArea, setUnitsArea] = useState(data?.area || '');
  const [rooms, setRooms] = useState(data?.noOfRooms || '');
  const [bathRooms, setBathRooms] = useState(data?.noOfBathrooms || '');
  const [carParking, setCarParking] = useState(data?.carParking || '');
  const [unitImagesAndPlan, setUnitImagesAndPlan] = useState(data?.images || []);
  const [unitExAmenities, setUnitExAmenities] = useState(
    exteriorAmenities?.filter((e) => data?.exteriorAmenities?.includes(e._id)) || ''
  );

  // new image states
  const [isUploadingImages, setIsUploadingImages] = useState(false);

  const { t } = useTranslation('dashboardProjects', { lng: language?.value });

  const [unitInAmenities, setUnitInAmenities] = useState(
    interiorAmenities?.filter((e) => data?.interiorAmenities?.includes(e?._id)) || ''
  );

  const deleteMedia = async (e) => {
    const res = await deletePropertyMedia(e);
    if (res?.data) {
      setUnitImagesAndPlan((prev) => prev.filter((a) => a !== e?.key));
      toast.success('Media deleted successfully');
    }
  };

  const handleSubmit = async () => {
    const body = {
      unitType: unitsType?._id,
      area: unitsArea,
      noOfRooms: rooms,
      noOfBathrooms: bathRooms,
      carParking: carParking,
      price: unitsPrice,
      exteriorAmenities: unitExAmenities?.map((e) => e._id),
      interiorAmenities: unitInAmenities?.map((e) => e._id),
      images: unitImagesAndPlan,
      ...(data?._id && { unitId: data?._id })
    };
    // validation

    for (let key in body) {
      if (body[key] === '') {
        if (key === 'carParking') continue;
        return toast.warn(t('projectUnitInformation.toast.fieldFillError'));
      }

      // if following fields are not valid number
      if (
        ['price', 'area', 'noOfBathrooms'].includes(key) &&
        // ['carParking', 'price', 'area', 'noOfBathrooms'].includes(key) &&
        (Number.isNaN(body[key]) || Number(body[key] <= 0))
      ) {
        return toast.warn(`${capitalizeEachWord(key)} should be a valid number and greater than 0`);
      }
    }

    const formData = CreateFormData(body);

    onClick(formData, { projectId: data?._id });
  };
  return (
    <ModalSkeleton width={'1100px'} show={show} setShow={setShow} modalClass={classes.modal}>
      <Container>
        <Row
          className={`
        ${classes.modal_row}
        ${[['ar', 'fa']?.includes(language?.value) ? 'rtl' : 'ltr'].join(' ')}`}>
          <Col md={12}>
            <h4>{t('projectUnitInformation.modalTitle')}</h4>
          </Col>
          <Col md={12}>
            <div className={classes.headAndDropDown}>
              <FormLanguages value={language} setter={setLanguage} />
            </div>
          </Col>
          <Col md={6}>
            <DropDown
              label={t('projectUnitInformation.projectUnitsType')}
              placeholder={t('projectUnitInformation.projectUnitsTypePlaceholder')}
              // options={propertyStatusOptions}
              variant="dashboard"
              indicatorColor="var(--dashboard-text-gray-clr)"
              options={unitTypes}
              getOptionValue={(e) => e?.title?.[language?.value]}
              getOptionLabel={(e) => e?.title?.[language?.value]}
              value={unitsType}
              setValue={setUnitsType}
            />
          </Col>
          <Col md={6}>
            <Input
              customStyle={{
                height: '55px'
              }}
              type={'number'}
              label={t('projectUnitInformation.projectUnitsArea')}
              placeholder={t('projectUnitInformation.projectUnitsAreaPlaceholder')}
              variant="dashboard"
              value={unitsArea}
              setValue={setUnitsArea}
            />
          </Col>
          <Col md={6}>
            <DropDown
              type={'number'}
              label={t('projectUnitInformation.noOfRooms')}
              placeholder={t('projectUnitInformation.noOfRoomsPlaceholder')}
              variant="dashboard"
              indicatorColor="var(--dashboard-text-gray-clr)"
              value={rooms}
              setValue={setRooms}
              getOptionValue={(e) => e?.[language?.value]}
              getOptionLabel={(e) => e?.[language?.value]}
              options={roomsOptions}
            />
          </Col>
          <Col md={6}>
            <Input
              customStyle={{
                height: '55px'
              }}
              label={t('projectUnitInformation.noOfBathrooms')}
              placeholder={t('projectUnitInformation.noOfBathroomsPlaceholder')}
              variant="dashboard"
              value={bathRooms}
              setValue={setBathRooms}
              // options={NoOfUnitsOptions}
              type={'number'}
            />
          </Col>
          <Col md={6}>
            <Input
              customStyle={{
                height: '55px'
              }}
              label={t('projectUnitInformation.carParking')}
              placeholder={t('projectUnitInformation.carParkingPlaceholder')}
              variant="dashboard"
              value={carParking}
              setValue={setCarParking}
              type={'number'}
              zeroAllowed={true}
            />
          </Col>
          <Col md={6}>
            <Input
              customStyle={{
                height: '55px'
              }}
              label={t('projectUnitInformation.unitPrice')}
              placeholder={t('projectUnitInformation.unitPricePlaceholder')}
              variant="dashboard"
              value={unitsPrice}
              setValue={setUnitsPrice}
              type={'number'}
            />
          </Col>

          <Col md={12}>
            <label className={classes.label}>{t('projectUnitInformation.projectUnitsPlans')}</label>
            <Row className="gy-3">
              {unitImagesAndPlan?.map((item, index) => (
                <Col md={3} key={`${item}${index.toString()}`}>
                  <UploadImageBox
                    value={item}
                    edit={false}
                    onDelete={() => {
                      deleteMedia({ type: 'images', key: item });
                    }}
                  />
                </Col>
              ))}
            </Row>
          </Col>
          <Col md={12}>
            <FileUpload
              // label={t('projectUnitInformation.projectUnitsPlans')}
              // files={unitImagesAndPlan}
              files={[]}
              setFiles={(e) => {
                uploadImagesHelper({
                  images: e,
                  setIsLoading: setIsUploadingImages,
                  setImages: setUnitImagesAndPlan,
                  token: accessToken
                });
              }}
            />
          </Col>
          <Col md={6}>
            <DropDown
              label={t('projectUnitInformation.exteriorAmenities')}
              placeholder={t('projectUnitInformation.exteriorAmenitiesPlaceholder')}
              variant="dashboard"
              value={unitExAmenities}
              setValue={setUnitExAmenities}
              indicatorColor="var(--dashboard-text-gray-clr)"
              getOptionValue={(e) => e?.title?.[language?.value]}
              getOptionLabel={(e) => e?.title?.[language?.value]}
              options={exteriorAmenities}
              isMulti={true}
            />
          </Col>
          <Col md={6}>
            <DropDown
              label={t('projectUnitInformation.interiorAmenities')}
              placeholder={t('projectUnitInformation.interiorAmenitiesPlaceholder')}
              variant="dashboard"
              value={unitInAmenities}
              setValue={setUnitInAmenities}
              indicatorColor="var(--dashboard-text-gray-clr)"
              options={interiorAmenities}
              getOptionValue={(e) => e?.title?.[language?.value]}
              getOptionLabel={(e) => e?.title?.[language?.value]}
              optionLabel={t('projectUnitInformation.interiorAmenitiesOptionLabel')}
              optionValue={t('projectUnitInformation.interiorAmenitiesOptionValue')}
              isMulti={true}
            />
          </Col>
          <Col className="text-center mt-4">
            <Button
              disabled={isApiCall}
              label={
                isApiCall
                  ? t('projectUnitInformation.submitBtnLoading')
                  : t('projectUnitInformation.submitBtn')
              }
              onClick={handleSubmit}
            />
          </Col>
        </Row>
      </Container>

      {(isUploadingImages || isDeletingMedia) && <LottieLoader />}
    </ModalSkeleton>
  );
};

export default UnitAddModal;
